import "./horizontaldivider.scss";

const HorizontalDivider = () => {
    return(
        <div className="Horizontal-Divider"/>
    );
}

export default HorizontalDivider